import axios from 'axios';
import appConfig from '@/config';
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;


export function getComplianceInfo(){
    const url = `${BASE_URL}/verified`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        }
    })
}


export function verifiedService(dataObj, name, email){
    const url = `${BASE_URL}/verified`;
    let token = getCookie('token');
    let merchantId = window.localStorage.getItem('merchantId');
    return axios({
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization':token,
            'merchant-id':merchantId
        },
        data: {
            merchantId: merchantId,
            email,
            data: dataObj,
            fieldsAndInputs: '',
            name,
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/verified/verifiedServices.js